export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/text_message_marketing.5e71fa5.svg";